import { ChangeDetectionStrategy, Component } from '@angular/core';
import { BaseModalComponent } from '../../../../core/layout/components/abstracts/base-modal.component';
import { ICustomer } from '../../core/interfaces/ICustomer';
import { ModalComponent } from '../../../../shared/components/modal/modal.component';
import { TranslatePipe } from '../../../../shared/pipes/trans.pipe';
import { AddEditCustomerFormComponent } from '../../forms/add-edit-customer-form/add-edit-customer-form.component';

@Component({
  selector: 'app-add-customer-modal',
  standalone: true,
  imports: [
    ModalComponent,
    TranslatePipe,
    AddEditCustomerFormComponent
  ],
  templateUrl: './add-customer-modal.component.html',
  styleUrl: './add-customer-modal.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class AddCustomerModalComponent extends BaseModalComponent<ICustomer, AddEditCustomerFormComponent> {

  public isAdd = true;

  public constructor() {
    super();
    this.namespace = 'customers/add-customer-modal';
  }
}
